import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Constants
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
// Components
import {
  CoachStatusAligner,
  CoachStatusContainer,
  CoachStatusImg,
  CoachStatusText,
  CoachStatusButton,
  CoachStatusButtonBall,
} from "./styles";
import Axios from "../../../../config/axios";
// Assets
import CoachImg from "../../../../assets/icons/ico_coach.svg";

const CoachStatus = ({ isCoachStatus, setIsCoachStatus, isDisabledInputs }) => {
  const { patientId } = useParams();
  const [t] = useTranslation("global");

  // Fetching patient coach status
  useEffect(() => {
    Axios("get", `${WEB_SERVICE_MIMS}/coach/get-status/${patientId}`)
      .then(({ data }) => {
        setIsCoachStatus(data.isCoachActive);
      })
      .catch((error) => {
        console.log("endpoint to get patient coach status: ", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId]);

  return (
    <CoachStatusAligner>
      <CoachStatusContainer>
        <CoachStatusImg src={CoachImg} alt="ico-coach" />
        <CoachStatusText>{t("coach_title")}</CoachStatusText>
        <CoachStatusButton onClick={() => setIsCoachStatus(!isCoachStatus)} isCoachStatus={isCoachStatus} disabled={isDisabledInputs}>
          <CoachStatusButtonBall isCoachStatus={isCoachStatus}></CoachStatusButtonBall>
        </CoachStatusButton>
      </CoachStatusContainer>
    </CoachStatusAligner>
  );
};

export default CoachStatus;
